import coupon from '../views/coupon'

export default {
  path: '/coupon',
  component: coupon,
  redirect: '/coupon/templates',
  name: 'Coupon',
  meta: {
    title: '优惠券管理'
  },
  children: [
    {
      path: '/coupon/templates',
      component: () => import('@/views/coupon/Templates'),
      name: 'CouponTemplates',
      meta: { title: '券模板管理' }
    },
    {
      path: '/coupon/list',
      component: () => import('@/views/coupon/Coupons'),
      name: 'CouponList',
      meta: { title: '优惠券列表' }
    },
    {
      path: '/coupon/send',
      component: () => import('@/views/coupon/Send'),
      name: 'CouponSend',
      meta: { title: '批量发券' }
    },
    {
      path: '/coupon/logs',
      component: () => import('@/views/coupon/SendLogs'),
      name: 'CouponLogs',
      meta: { title: '发券记录' }
    },
    {
      path: '/coupon/flows',
      component: () => import('@/views/coupon/Flows'),
      name: 'CouponFlows',
      meta: { title: '优惠券流水' }
    },
    {
      path: '/coupon/stat',
      component: () => import('@/views/coupon/Stat'),
      name: 'CouponStat',
      meta: { title: '数据统计' }
    }
  ]
}
